import styled, { css } from 'styled-components';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { media } from 'src/ui/common/mixins/media';
import { Typography } from 'src/ui/common/atoms/typography';

export const StyledTitle = styled(FlexBox)`
  color: white;
  
  button {
    height: 34px;
  }
`;

export const StyledActions = styled.div<{ actionsCount: number }>`
  margin-top: 20px;
  display: grid;
  grid-template-columns: [col] 1fr [col] 1fr;
  grid-template-rows: [row] auto [row] auto [row];
  column-gap: 10px;
  row-gap: 10px;

  button {
    width: 100%;
    height: 40px;

    ${media.md(css`
      height: 50px;
    `)}

    svg {
      margin-right: 10px;
    }
  }

  ${({ actionsCount }: { actionsCount: number }) => actionsCount === 1 && `
    button:first-child {
      grid-column: col 1 / span 2;
      grid-row: row 1;
    }
  `}

  ${({ actionsCount }: { actionsCount: number }) => actionsCount === 2 && `
    button:first-child {
      grid-column: col 1 / span 2;
      grid-row: row 1;
    }

    button:nth-child(2) {
      grid-column: col 1 / span 2;
      grid-row: row 2;
    }
  `}

  ${({ actionsCount }: { actionsCount: number }) => actionsCount === 3 && `
    button:first-child {
      grid-column: col 1 / span 2;
      grid-row: row 1;
    }

    button:nth-child(2) {
      grid-column: col 1 / span 1;
      grid-row: row 2;
    }

    button:nth-child(3) {
      grid-column: col 2 / span 1;
      grid-row: row 2;
    }
  `};

  ${({ actionsCount }: { actionsCount: number }) => actionsCount === 4 && `
    button:first-child {
      grid-column: col 1 / span 2;
      grid-row: row 1;
    }

    button:nth-child(2) {
      grid-column: col 1 / span 1;
      grid-row: row 2;
    }

    button:nth-child(3) {
      grid-column: col 2 / span 1;
      grid-row: row 2;
    }
    
    button:nth-child(4) {
      grid-column: col 1 / span 2;
      grid-row: row 3;
    }
  `};

  ${({ actionsCount }: { actionsCount: number }) => actionsCount === 5 && `
    button:first-child {
      grid-column: col 1 / span 2;
      grid-row: row 1;
    }

    button:nth-child(2) {
      grid-column: col 1 / span 1;
      grid-row: row 2;
    }

    button:nth-child(3) {
      grid-column: col 2 / span 1;
      grid-row: row 2;
    }
    
    button:nth-child(4) {
      grid-column: col 1 / span 1;
      grid-row: row 3;
    }

    button:nth-child(5) {
      grid-column: col 2 / span 1;
      grid-row: row 3;
    }
  `};

  ${media.md`
    grid-template-columns: [col] 1fr [col] 1fr [col] 1fr [col] 1fr;

    ${({ actionsCount }: { actionsCount: number }) => actionsCount === 1 && `
      button:first-child {
        grid-column: col 1 / span 4;
        grid-row: row 1;
      }
    `}

    ${({ actionsCount }: { actionsCount: number }) => actionsCount === 2 && `
      button:nth-child(2) {
        grid-column: col 3 / span 2;
        grid-row: row 1;
      }
    `}

    ${({ actionsCount }: { actionsCount: number }) => actionsCount === 3 && `
      button:nth-child(2) {
        grid-row: row 1;
        grid-column: col 3 / span 1;
      }

      button:nth-child(3) {
        grid-row: row 1;
        grid-column: col 4 / span 1;
      }
    `}

    ${({ actionsCount }: { actionsCount: number }) => actionsCount === 4 && `
      button:nth-child(2) {
        grid-column: col 3 / span 1;
        grid-row: row 1;
      }

      button:nth-child(3) {
        grid-column: col 4 / span 1;
        grid-row: row 1;
      }
      
      button:nth-child(4) {
        grid-column: col 1 / span 4;
        grid-row: row 2;
      }
   `};

    ${({ actionsCount }: { actionsCount: number }) => actionsCount === 5 && `
      grid-template-columns: [col] 1fr [col] 1fr [col] 1fr [col] 1fr [col] 1fr [col] 1fr;

      button:first-child {
        grid-column: col 1 / span 3;
        grid-row: row 1;
      }

      button:nth-child(2) {
        grid-column: col 4 / span 3;
        grid-row: row 1;
      }

      button:nth-child(3) {
        grid-column: col 1 / span 2;
        grid-row: row 2;
      }
      
      button:nth-child(4) {
        grid-column: col 3 / span 2;
        grid-row: row 2;
      }

      button:nth-child(5) {
        grid-column: col 5 / span 2;
        grid-row: row 2;
      }
    `};
  `};
`;

export const StyledPriceRow = styled(FlexBox)`
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  margin-top: 20px;
  
  ${media.sm`
    font-size: 20px;
    
    & > div:first-child {
      display: flex;
    }
  `}
`;

export const StyledFiatPrice = styled.div`
  & svg {
    margin-right: 7px;
  }
  
  & + div {
    margin-top: 16px;
  }
  
  ${media.sm`
    & + div {
      margin-top: 0;
      margin-left: 24px;
    }
  `}
`;

export const StyledRoyalties = styled.div`
  ${media.sm`
    margin-left: auto;
  `}
`;

export const StyledLabel = styled(Typography)`
  color: ${({ theme }) => theme.colors.gs200};
  margin-bottom: 12px;

  ${media.sm`
    font-size: 16px;
  `}
`;

export const StyledDescription = styled(Typography)`
  text-align: start;
  width: 278px;
  white-space: break-spaces;
`;

export const StyledLearnMore = styled(Typography)`
  margin-top: 20px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`;
